import React from 'react'
import Footer from 'components/layout/Footer/index'
import AppInitializer from 'components/layout/AppInitializer/index'

const PublicRoute = ({ Component, isHeader, isFooter, child }) => {
  return (
    <>
      {isHeader ? <AppInitializer /> : <></>}
      <div className='flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden'>
        <Component child={child} />
      </div>
      {isFooter ? <Footer /> : <></>}
    </>
  )
}

export default PublicRoute
